@use "../../styles/colors";

:global {
  body[class*="theme-"].theme {
    :local {
      .clickable {
        cursor: pointer;
      }
    }
  }
}
